import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'D:\\IWF\\Apps\\app-component\\node_modules\\css-loader\\dist\\runtime\\api.js'
import 'D:\\IWF\\Apps\\app-component\\node_modules\\vue-style-loader\\lib\\addStylesShadow.js'
import 'D:\\IWF\\Apps\\app-component\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js'

window.customElements.define('credence-file-upload', wrap(Vue, () => import('~root/./src/StandaloneWebComponent/FileUpload.vue?shadow')))

window.customElements.define('credence-macro', wrap(Vue, () => import('~root/./src/StandaloneWebComponent/macro.vue?shadow')))

window.customElements.define('credence-mega-menu-web-component', wrap(Vue, () => import('~root/./src/StandaloneWebComponent/MegaMenuWebComponent.vue?shadow')))

window.customElements.define('credence-search', wrap(Vue, () => import('~root/./src/StandaloneWebComponent/search.vue?shadow')))